'use client'
import { useEventBus } from '@/libs/hooks/use-event-bus';
import { FeedDto } from '@/libs/api/feed';

// Event name for feed comment status changes (must match the one in useComments)
const FEED_COMMENT_EVENT = 'feed-comment-status-change';

// Event payload type
interface FeedCommentEvent {
  feedId: string;
  commentCount: number;
}

/**
 * Hook for listening to feed comment events and updating feed data
 * @param setFeeds Function to edit feeds state
 */
export const useFeedCommentEvent = (
  setFeeds: React.Dispatch<React.SetStateAction<FeedDto[]>>
) => {
  // Listen for feed comment events
  useEventBus<FeedCommentEvent>(FEED_COMMENT_EVENT, (data) => {
    setFeeds(prevFeeds => {
      return prevFeeds.map(feed => {
        // Only edit the feed that matches the event feedId
        if (feed.sid === data.feedId) {
          // Return updated feed with new comment count
          return {
            ...feed,
            commentCount: data.commentCount
          };
        }
        return feed;
      });
    });
  });
};